import React, { useMemo } from 'react';
import styles from './ShopHeader.module.scss';

/* Translations */
import { tr } from '../../../../utils/translations/translator';
import { useTranslation } from 'react-i18next';

/* Interfaces */
import { StoreType } from '../../../PaymentGateway/interfaces/store_types';
import { ShopProduct, TipsterInfo } from '../interfaces';
import { TipProduct } from '../../Tip/interfaces/TipProduct';

interface ShopHeaderProps {
  store: StoreType;
  product: ShopProduct;
  tipsterInfo: TipsterInfo;
  isTipster?: boolean;
}

export const ShopHeader: React.FC<ShopHeaderProps> = ({
  store,
  product,
  tipsterInfo,
  isTipster = false,
}) => {
  const { t } = useTranslation();
  const title = useMemo(() => {
    if (store === 'PREMIUM') {
      return <p className={styles[store]}>{tr(t, 'PREMIUM')}</p>;
    } else {
      const tipProduct = product as TipProduct;
      return (
        <p className={styles[tipProduct.tip.price_type + '_tip']}>
          {tr(t, tipProduct.tip.price_type)}
        </p>
      );
    }
  }, [store, product]);

  return (
    <div
      className={styles.container}
      id={isTipster ? styles.isTipster : styles.isUser}
    >
      <div className={styles.fixedWrapper}>
        <img src={tipsterInfo.avatar_url} alt="tipster avatar" />
        <div className={styles.bottom}>
          <h1> {tipsterInfo.name}</h1>
          {title}
        </div>
      </div>
    </div>
  );
};
